module.exports = __webpack_public_path__ + "static/media/constructionSite-de.1d341c31.jpeg";